import { useState, useEffect } from "react";
import { axiosPublic } from "../../Utils/axios";

export const useFetchData = (url,lang) => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
//   const lang = localStorage.getItem("i18nextLng");
  useEffect(() => {
    const controller = new AbortController()

    const fetchData = async () => {
      setIsLoading(true);
      await axiosPublic
        .get(url, {
          headers: { lang: lang === "fa" ? "dr" : "en" },
          signal: controller.signal,
        })
        .then((response) => {
          if (response.data.success) {
            setData(response.data.data);
             setIsLoading(false);
          } else {
            setIsError(true);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setIsError(true);
          console.error(error.message);
        });
    };
    fetchData();
    return () => {
      controller.abort()
    };
  }, [url, lang]);

  return { data, isLoading, isError };
};